import LSElementor from './live-streaming-elementor.js';
import LSAppend from './live-streaming-append.js';
import '../css/live-streaming-frontend.css';
import './../css/live-streaming-epg.css';

document.addEventListener("DOMContentLoaded", () => {
    // Initialize custom modules
    const DashboardSideBarModule = {
        ls_elementor: new LSElementor(),
        ls_append: new LSAppend(),
    };

    // Expose to global scope
    window.DashboardSideBarModule = DashboardSideBarModule;

    if (LSFrontendAjax.ls_epg_enabled) {
        import('./epg-manager.js').then(module => {
            const EPGManager = module.default;
            const epgContainer = document.getElementById('ls-epg-container');

            if (LSFrontendAjax.ls_epg_enabled && epgContainer) {
                // Get channel ID from data attribute
                const singleChannelId = epgContainer.getAttribute('data-single-channel-id');
                // Initialize EPG with channel ID
                new EPGManager('ls-epg-container', singleChannelId);
            }
        });
    }
});
